import { __rest } from 'tslib';
import React from 'react';
import { useTheme, useColor } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root, Content, Bubble } from './styled.js';

const BaseDot = (_a, ref) => {
    var { preset = 'red', before, after, children, offset = [0, 0], placement = 'rightTop', className, rootClassName, inline = true, color } = _a, props = __rest(_a, ["preset", "before", "after", "children", "offset", "placement", "className", "rootClassName", "inline", "color"]);
    const theme = useTheme();
    const _color = useColor(color);
    return (React.createElement(Root, { ref: ref, theme: theme, className: cn(['tend-ui-dot-root', rootClassName]) },
        before && (React.createElement(Content, { className: 'tend-ui-dot-before', theme: theme }, before)),
        children,
        React.createElement(Bubble, Object.assign({ "data-testid": 'tend-ui-dot' }, props, { theme: theme, "$inline": inline, "$backgroundColor": _color, "$preset": preset, "$offset": offset, "$placement": placement, "$pointer": !!props.onClick, className: cn(['tend-ui-dot-dot', className]) })),
        after && (React.createElement(Content, { className: 'tend-ui-dot-after', theme: theme }, after))));
};
const Dot = React.forwardRef(BaseDot);
Dot.displayName = 'Dot';

export { Dot };
